export default __webpack_public_path__ + "static/media/copy.inline.ff355eb9.svg";